// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content.in-call[data-v-55fe8ef3] .app-content{background-color:rgba(0,0,0,0)}.content[data-v-55fe8ef3]:fullscreen{padding-top:0}.content[data-v-55fe8ef3]:fullscreen .app-sidebar{height:100vh !important}`, "",{"version":3,"sources":["webpack://./src/App.vue"],"names":[],"mappings":"AAIE,+CACC,8BAAA,CAKF,qCACC,aAAA,CAEA,kDACC,uBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
